define('widgets/form_date_field/viewmodel',[
    "i19n!i19n/strings"
],
function (i19n) {

    var Widget = function (element, settings) {
    };

    Widget.prototype.activate = function (settings) {
        var self = this;

        self.field = settings.field;
        self.hasFocus = ko.observable(false);
        self.hasBeenUpdated = ko.observable(false);
        self.isBusy = ko.observable(false);
        self.isDisabled = ko.computed(function () {
            return self.isBusy() || !self.field.editable();
        });

        self.isDisabled.subscribe(function (newValue) {
            if (datePicker)
                datePicker.enable(!newValue);
        });

        var inputValue;
        self.change = function (vm, event) {
            inputValue = event.currentTarget.value;
            // if we've entered in a non-parsable date then throw an error.
            if (datePicker && !datePicker.value() && inputValue) {
                self.field.value.setError(i19n.to.pleaseenteravalidvalue);
                self.isDirty(true); // simulating isDirty to prevent "updatedIndicator" from showing.
            } else {
                // otherwise clear the error
                self.field.value.clearError();

                // if the datepicker value hasn't changed from null due to a non-parsable date, then we need to force an update if the user explictely supplies a null/empty
                if (datePicker && !datePicker.value() && !inputValue) {
                    update(datePicker.value());
                }
            }

        };

        self.isDirty = ko.observable(false);

        self.showUpdatedIndicator = ko.computed(function () {
            return !self.hasFocus() && !self.isDirty() && self.hasBeenUpdated();
        });

        self.field.value.subscribe(function (newValue) {
            if (datePicker) {
                datePicker.value(newValue);
                self.isDirty(true);
            }
        });

        self.readOnlyValue = ko.computed(function () {
            var format = self.field.options() && self.field.options().format ? self.field.options().format : "g"; //d MMM yyyy hh:mm tt
            return kendo.toString(self.field.value(), format);
        });

        self.field.editable.subscribe(function (newValue) {
            self.hasBeenUpdated(false); // reset
        });
        self.field.editLayout = ko.observable(false);
        self.field.editLayout.focus = function () { }; //placeholder
        self.field.editLayout.isFocus = ko.observable(false);
        self.field.editLayout.editList = function () { };

        self.errors = ko.validation.group(self.field);
        self.isValid = ko.computed(function () {
            return self.errors().length == 0;
        });


        var datePicker;
        self.attached = function (viewHtml) {
            var options = self.field.options() || {};

            options.format = !options.format ? "g" : options.format; //d MMM yyyy hh:mm tt
            options.change = onChange;

            if (options.isDateTime)
                datePicker = $("input[type=text]", viewHtml).kendoDateTimePicker(options).data("kendoDateTimePicker");
            else
                datePicker = $("input[type=text]", viewHtml).kendoDatePicker(options).data("kendoDatePicker");

            $("input.controls-is-visible:checkbox", viewHtml).change(function () {
                self.field.visible(this.checked);
            });
        };

        function onChange() {
            // if value didn't actually change then get out of here...
            var currentText = self.field.value() || "";
            if (currentText == datePicker.value())
                return;

            if (datePicker.value() != null || inputValue == "")
                update(datePicker.value());
        }

        function update(value) {
            self.field.value(value);
            self.hasFocus(false);
            self.isBusy(true);
            if (self.isValid()) {
                settings.update(self.field)
                    .done(function () {
                        self.hasBeenUpdated(true);
                        self.isDirty(false);
                    })
                    .always(function () {
                        self.isBusy(false);
                    });
            } else {
                self.errors.showAllMessages();
                self.isBusy(false);
            }
        }
    };    

    return Widget;
});
